export function AppBrand({ tagline = false }: { tagline?: boolean }) {
  return (
    <>
      <img className="brand-mark" src="/novaroll-mark.svg" alt="" aria-hidden="true" />
      <span className="brand-copy">
        <strong>NOVAROLL</strong>
        {tagline && <small>Pallet load monitor</small>}
        <span className="app-version">v{__APP_VERSION__}</span>
      </span>
    </>
  )
}
